<div class="dashboard">

  <div class="dashboard-boxes">

    <div class="dashboard-box __revenue" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Revenue</span>
      <span class="dashboard-box-count">{{ revenue | currency: 'USD': 'symbol' : '1.0-0' }}</span>
    </div>

    <div class="dashboard-box __units-sold" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Units Sold</span>
      <span class="dashboard-box-count">{{unitsSold}}</span>
    </div>

    <div class="dashboard-box __open-orders" (click)="goTo('purchase-orders')" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Open Orders</span>
      <span class="dashboard-box-count">
        {{ orderCounters.openOrdersTotal }} | {{orderCounters.openOrdersAmount | currency: 'USD': 'symbol' : '1.0-0' }}
      </span>
    </div>

    <div class="dashboard-box __pending-sold" (click)="goTo('pending-sold')" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Pending PO</span>
      <span class="dashboard-box-count">
        {{ orderCounters.pendingPOTotal }} | {{orderCounters.pendingPOAmount | currency: 'USD': 'symbol' : '1.0-0' }}
      </span>
    </div>

  </div>

  <div class="dashboard-info" *ngIf="orderCounters && orderCounters.missingTrackingTotal > 0">
    <span class="dashboard-info__text">
      <span routerLink="/vendor/purchase-orders">
        You have {{orderCounters.missingTrackingTotal}} purchase order(s) missing tracking
      </span>
    </span>
  </div>

  <div class="dashboard-charts">

    <div class="dashboard-chart">

      <div class="dashboard-chart-heading">
        <h2>Performance</h2>
      </div>

      <div (click)="clickedInsideDatePicker($event)" class="dashboard-chart-date"
        *ngIf="dashboardService.vendorHasItems">
        <div (click)="showDaterangePicker($event)">
          <input type="text" class="form-control" #dashboardDp="bsDaterangepicker" [bsConfig]="bsConfig"
            [bsValue]="dateRangeValues" placement="left" bsDaterangepicker triggers='custom'>
        </div>

        <div class="dashboard-chart-date-wrapper" *ngIf="isDatePickerOpen">
          <div class="dashboard-chart-date-btns">
            <div class="today-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.today"
                (click)="changeDateRanges($event, 0, daterangesEnum.today)">Today</a>
            </div>

            <div class="yesterday-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.yesterday"
                (click)="changeDateRanges($event, 1, daterangesEnum.yesterday)">Yesterday</a>
            </div>

            <div class="last-seven-days">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.last7days"
                (click)="changeDateRanges($event, 7, daterangesEnum.last7days)">Last 7 Days</a>
            </div>

            <div class="last-thirty-days">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.last30days"
                (click)="changeDateRanges($event, 30, daterangesEnum.last30days)">Last 30 Days</a>
            </div>

            <div class="current-month-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.thisMonth"
                (click)="changeDateRanges($event, null, daterangesEnum.thisMonth)">This Month</a>
            </div>

            <div class="last-month-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.lastMonth"
                (click)="changeDateRanges($event, null, daterangesEnum.lastMonth)">Last Month</a>
            </div>

            <div class="custom-range-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.customRange"
                (click)="changeDateRanges($event, null, daterangesEnum.customRange)">Custom Range</a>
            </div>
          </div>

          <bs-daterangepicker-inline *ngIf="bsConfig" [bsConfig]="bsConfig" [bsValue]="dateRangeValues"
            (bsValueChange)="onDateValueChange($event)" #inlineDatePicker></bs-daterangepicker-inline>


          <div class="dashboard-chart-date-bottom">
            <a class="btn btn-cancel" (click)="closeDatepicker()">Cancel</a>
            <a class="btn btn-apply" (click)="getPerformanceChartData()">Apply</a>
          </div>

        </div>
      </div>

      <app-chart  #performanceChart
        [series]="performanceChartData?.series" [categories]="performanceChartData?.categories"
        [totalUnits]="totalUnits" [totalRevenue]="totalRevenue" *ngIf="!loadingPerformanceChartData && !isPerformanceChartEmpty">
      </app-chart>

<!-- Empty state -->
      <div class="dashboard-empty-state __perfomance" *ngIf="!loadingPerformanceChartData && isPerformanceChartEmpty">
        <div class="dashboard-empty-state-modal__wrap">
          <div class="dashboard-empty-state-modal">
            <h3>No Sales Yet</h3>
            <p>Your sales will show here once made</p>
          </div>
        </div>

        <div class="dashboard-empty-state__perfomance-chart">
          <div class="dashboard-empty-state__perfomance-text">
            <span>$40</span>
            <span>$30</span>
            <span>$20</span>
            <span>$10</span>
            <span>$0</span>
          </div>
          <div class="dashboard-empty-state__perfomance-img">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="253" preserveAspectRatio="none" viewBox="0 0 529 253"><g fill="none" fill-rule="evenodd"><line x1=".5" x2="528.5" y1="16.5" y2="16.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="75.5" y2="75.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="134.5" y2="134.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="193.5" y2="193.5" stroke="#E0E0E0"/><path stroke="#1A1A1A" stroke-linejoin="round" stroke-width="6" d="M39,252 C39,246.336191 52.5663188,235.898399 60.0163138,232.759584 C79.2018647,224.67637 98.2888374,226.135415 112.24376,226.135415 C136.80769,226.135415 152.92433,205.06019 179.820262,208.255132 C197.777521,210.388258 203.219676,207.362312 221.183227,166.944224 C239.146778,126.526136 248.099041,106.431814 261.270613,106.431814 C307.392423,106.431814 301.984984,48 330.796061,48 C354.006121,48 356.769567,113.362323 375.495994,123.773617 C399.158989,136.929486 396.584494,103.567812 423.518334,105.239169 C453.502126,107.099788 463.147692,181.158306 498.087323,212.661763 C509.818379,223.239115 526.837025,222.711198 529,222.711198" opacity=".05"/><path stroke="#80CB5E" stroke-width="6" d="M39,253 C39,236.415928 79.2075768,169.403367 115.992159,169.403367 C142.094627,169.403367 161.070243,99.1669143 183.510347,101.841369 C189.989544,102.613572 194.425238,107.728357 203.479114,106.339921 C227.450307,102.663875 235.483485,40.8147603 264.980592,37.2149651 C293.408262,33.7456829 313.587659,73.5952818 349.332713,61.2141066 C381.103778,50.20942 385.51118,143.835784 411.223504,173.708514 C417.869685,181.430087 425.158975,173.708514 435.211393,173.708514 C462.808431,173.708514 480.269646,228.205412 498.669308,228.205412 C517.068971,228.205412 515.096739,188.155359 522.858161,177.432436 C524.78364,174.772258 527.291245,173.708514 529,173.708514" opacity=".05"/><line x1=".5" x2="528.5" y1="252.5" y2="252.5" stroke="#E0E0E0"/><line x1=".5" x2=".5" y1="-1" y2="253" stroke="#E0E0E0"/><line x1="528.5" x2="528.5" y1="-1" y2="253" stroke="#E0E0E0"/></g></svg>
          </div>
          <div class="dashboard-empty-state__perfomance-text">
            <span>1k</span>
            <span>750</span>
            <span>500</span>
            <span>250</span>
            <span>0</span>
          </div>
        </div>

        <div class="dashboard-empty-state__perfomance-legend-wrap">
          <div class="dashboard-empty-state__perfomance-legend _units">
            <div class="_qty">
                0
            </div>
            <div>
              <span> Units </span>
              <span class="_line"></span>
            </div>
          </div>
          <div class="dashboard-empty-state__perfomance-legend _revenue">
            <div class="_qty">
                $0
            </div>
            <div>
              <span> Revenues </span>
              <span class="_line"></span>
            </div>
          </div>
        </div>
      </div>

<!-- Preloader -->
      <div class="dashboard-preloader __perfomance" *ngIf="loadingPerformanceChartData">

        <div class="dashboard-preloader-chart">
          <div class="dashboard-preloader-text">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="250" viewBox="0 0 32 250"><g fill="none" fill-rule="evenodd"><rect width="32" height="14" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="59" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="118" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="177" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="236" fill="#EAEAEA" rx="7"/></g></svg>
          </div>
          <div class="dashboard-preloader-img">

            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="253" preserveAspectRatio="none" viewBox="0 0 529 253"><g fill="none" fill-rule="evenodd"><line x1=".5" x2="528.5" y1="16.5" y2="16.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="75.5" y2="75.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="134.5" y2="134.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="193.5" y2="193.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="252.5" y2="252.5" stroke="#E0E0E0"/><line x1=".5" x2=".5" y1="-1" y2="253" stroke="#E0E0E0"/><line x1="528.5" x2="528.5" y1="-1" y2="253" stroke="#E0E0E0"/></g></svg>
          </div>
          <div class="dashboard-preloader-text">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="250" viewBox="0 0 32 250"><g fill="none" fill-rule="evenodd"><rect width="32" height="14" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="59" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="118" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="177" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="236" fill="#EAEAEA" rx="7"/></g></svg>
          </div>
        </div>

        <div class="dashboard-preloader-legend-wrap">
          <div class="dashboard-preloader-legend">
            <div class="_qty">
              <span></span>
            </div>
            <div>
              <span> Units </span>
              <span class="_line"></span>
            </div>
          </div>
          <div class="dashboard-preloader-legend">
            <div class="_qty">
              <span></span>
            </div>
            <div>
              <span> Revenues </span>
              <span class="_line"></span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="dashboard-chart">
      <div class="dashboard-chart-heading">
        <h2>Listing Details</h2>
      </div>
      <div class="dashboard-chart-listing" [class.hide]="listingDetailsChart.isLoading || !dashboardService.vendorHasItems">
        <div class="dashboard-chart-listing__big">
          <app-listing-details #listingDetail></app-listing-details>
          <div class="dashboard-chart-listing__big-counter" *ngIf="dashboardService.totalListing">
            {{ dashboardService.totalListing?.count }}
            <span>Total Listings</span>
          </div>
        </div>
        <div class="dashboard-chart-listing__small">
          <div class="chart-item" *ngFor="let status of dashboardService.listingStatuses"
            [routerLink]="'/vendor/items/status/' + status.name">
            <div class="chart-item-left">
              <span class="chart-item-left__heading"> {{ status.name }}</span>
              <span class="chart-item-left__value">{{ status.count }} Listings</span>
            </div>
            <app-mini-progress-chart [count]='status.count' [percentage]="getPercentageProgress(status.count)"
              [color]="getColorByStatusName(status.name)"></app-mini-progress-chart>
          </div>

        </div>
      </div>

      <div class="dashboard-empty-state __listing-details" *ngIf="!dashboardService.vendorHasItems && !listingDetailsChart.isLoading">
        <div class="dashboard-empty-state__label">Your product listings will display here</div>
        <!-- Drawn, no longer two pictures: the old ones were a coloured donut and six boxes from
             before Pending existed. The donut is the plain grey ring, and the boxes are the real
             statuses (all at 0, Pending included, in the strip's order) as the full view draws them. -->
        <div class="dashboard-empty-state__listing-details">
          <div class="dashboard-empty-state__listing-details-left">
            <svg xmlns="http://www.w3.org/2000/svg" width="282" height="282" viewBox="0 0 305 305" aria-label="listing details empty">
              <path fill="#DADADA" d="M152.5,0 C236.723424,0 305,68.2765757 305,152.5 C305,236.723424 236.723424,305 152.5,305 C68.2765757,305 0,236.723424 0,152.5 C0,68.2765757 68.2765757,0 152.5,0 Z M152.5,46 C93.6816741,46 46,93.6816741 46,152.5 C46,211.318326 93.6816741,259 152.5,259 C211.318326,259 259,211.318326 259,152.5 C259,93.6816741 211.318326,46 152.5,46 Z"/>
            </svg>
          </div>
          <div class="dashboard-empty-state__listing-details-right">
            <div class="chart-item __empty" *ngFor="let status of dashboardService.listingStatuses">
              <div class="chart-item-left">
                <span class="chart-item-left__heading">{{ status.name }}</span>
                <span class="chart-item-left__value">{{ status.count }} Listings</span>
              </div>
              <svg width="46" height="46" viewBox="0 0 46 46" aria-hidden="true">
                <rect x="2" y="2" width="42" height="42" rx="12" fill="none" stroke="#1A1A1A" stroke-width="4" opacity="0.06"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

<!-- Preloader Listing details chart -->
      <div class="dashboard-preloader __listing-details" *ngIf="listingDetailsChart.isLoading">

        <div class="dashboard-preloader-chart">
          <div class="dashboard-preloader-img">
           <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" viewBox="0 0 305 305"><path fill="#EAEAEA" d="M152.5,0 C236.723424,0 305,68.2765757 305,152.5 C305,236.723424 236.723424,305 152.5,305 C68.2765757,305 0,236.723424 0,152.5 C0,68.2765757 68.2765757,0 152.5,0 Z M152.5,46 C93.6816741,46 46,93.6816741 46,152.5 C46,211.318326 93.6816741,259 152.5,259 C211.318326,259 259,211.318326 259,152.5 C259,93.6816741 211.318326,46 152.5,46 Z"/></svg>
          </div>
          <div class="dashboard-preloader-details">
            <svg xmlns="http://www.w3.org/2000/svg" width="198" height="416" viewBox="0 0 198 416">
              <!-- HUBX-8464: seven skeleton boxes on the same metrics as .chart-item (56px tall,
                   4px apart, 46px badge), redrawn from the original single-path blob as plain rects
                   so the next status added here is one more <g> rather than hand-edited path data. -->
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(0 0)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 60)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 120)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 180)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 240)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 300)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
                <g transform="translate(0 360)">
                  <rect width="198" height="56" fill="#FFF" rx="12"/>
                  <rect x="24" y="11" width="60" height="14" fill="#F6F6F6" rx="7"/>
                  <rect x="24" y="37" width="80" height="7" fill="#F6F6F6" rx="3.5"/>
                  <rect x="141" y="7" width="42" height="42" stroke="#F6F6F6" stroke-width="4" rx="12"/>
                </g>
              </g>
            </svg>
          </div>
        </div>

      </div>

    </div>

  </div>

  <div class="dashboard-items-wrap">

    <div class="dashboard-items __just-sold">
      <div class="dashboard-items-heading">
        <h2>Just Sold on HUBX</h2>
      </div>
      <div class="dashboard-items-list" *ngIf="justSoldItems || justSoldScrollLoading || justSoldLoading">
        <ng-container *ngIf="justSoldItems && !justSoldLoading">
          <virtual-scroller [items]="justSoldItems" (vsEnd)="onScrollDownJustSold($event)" [scrollAnimationTime]="0"
            #scrollJustSold>
            <ng-container *ngFor="let item of  scrollJustSold.viewPortItems">
              <app-item-dashboard [item]="item"></app-item-dashboard>
            </ng-container>
            <app-dashboard-just-sold-preloader
              [class.hide]="!justSoldScrollLoading"></app-dashboard-just-sold-preloader>
          </virtual-scroller>
        </ng-container>
        <ng-container *ngIf="justSoldLoading">
          <app-vendor-items-preloader [source]="'dashboardJustSold'"></app-vendor-items-preloader>
        </ng-container>
      </div>

      <div *ngIf="!justSoldItems && !justSoldLoading" class="dashboard-empty-state">
        <div class="dashboard-empty-state__label">You have no items sold</div>
        <div class="dashboard-empty-state__just-sold-img">
          <img src="assets/images/vendor/dashboard-empty-state-1.png"
            srcset="assets/images/vendor/dashboard-empty-state-1@2x.png 2x" width="286" height="286"
            alt="just sold empty" />
        </div>
      </div>
    </div>

    <div class="dashboard-items __notifications">
      <div class="dashboard-items-heading">
        <h2><span routerLink="/vendor/notifications">Notifications</span></h2>
      </div>

      <div class="dashboard-items-list"
        [hidden]="!notificationCenter?.loading && notificationCenter?.notifications?.length < 1">
        <app-notification-center [isFromDashboard]="true"
          *ngIf="!vendorService.isVendorManager || vendorService.isImpersonationReady"></app-notification-center>
      </div>
      <div class="dashboard-empty-state"
        *ngIf="!notificationCenter?.loading && notificationCenter?.notifications?.length < 1">
        <div class="dashboard-empty-state__label">You have no notifications</div>
        <div class="dashboard-empty-state__notifications">
          <div class="dashboard-empty-state__notifications-row _top">
            <div>
              <div class="dashboard-empty-state__notifications-txt">
                <h3>Get ready to receive notifications from your buyers.</h3>
                <p>Buyers have the ability to notify you sellers 3 ways.</p>
                <ul class="dashboard-empty-state__notifications-list">
                  <li>
                    <img src="assets/images/vendor-icons/32-price-drop.svg" width="32" height="32" alt="price drop" />
                    <p>Waiting for <br />Price Drops</p>
                  </li>
                  <li>
                    <img src="assets/images/vendor-icons/32-back-to-stock.svg" width="32" height="32"
                      alt="back to stock" />
                    <p>Waiting for sold out items <br />to come back to stock</p>
                  </li>
                  <li>
                    <img src="assets/images/vendor-icons/32-more-inventory.svg" width="32" height="32"
                      alt="more inventory" />
                    <p>Waiting for more <br />inventory to be Added</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="dashboard-empty-state__notifications-row _btm">
            <div>
              <div class="dashboard-empty-state__notifications-txt">
                <h3>Instantly notify your buyers!</h3>
                <p>By updating your listing, the below buyers will instantly receive a SMS, Email, and notifications in
                  their HUBX buyers Portal! </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<app-error-modal [title]="'Server Error'" [isError]="errorModal.isError400" [bodyText]="errorModal.errorMessage400"
  (onConfirmError)="hideErrorAlert()"></app-error-modal>
